
import { defineComponent } from "vue";
import { AutoTyperVue } from "auto-typer-vue3";
export default defineComponent({
  name: "HomeView",
  components: {
    AutoTyperVue,
  },
  data() {
    return {
      typeText: [
        "I am...",
        "a Flutter Developer,",
        "a Traveler,",
        "a Cat Lover,",
        "and more...",
      ],
    };
  },
});
